var CommentClass = {
    options: {},
    init: function (options) {
        this.options = $.extend({}, this.options, options);
    },

    initLoadMore: function () {
        $(document).on('click', '.kf-view-more-comment', function (e) {
            e.preventDefault();
            let $container = $('.kf-comment__list');
            let $paginateButton = $(e.currentTarget);
            $paginateButton.prop('disabled', true);
            Common.buttonLoading($paginateButton, "Đang tải thêm các cảm nhận ...")
            let url = $paginateButton.data('url');

            function getDataForm() {
                let dataForm = $paginateButton.data('form');
                if (dataForm === undefined) {
                    dataForm = {
                        page: 1
                    }
                }
                if (dataForm.page === undefined) {
                    dataForm.page = 2;
                } else {
                    dataForm.page += 1;
                }
                return dataForm;
            }

            function setDataForm(dataForm) {
                $paginateButton.attr('data-form', JSON.stringify(dataForm));
            }

            let dataForm = getDataForm();
            $.ajax({
                type: 'GET',
                url: url,
                data: dataForm,
                dataType: 'json',
                success: function (resp) {
                    let items = resp.data;
                    let html = '';
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i];
                        html += `${item.html}`;
                    }
                    let $el = $(html);
                    $container.append($el)

                    if (resp.current_page >= resp.last_page) {
                        $paginateButton.fadeOut();
                    }

                },
                complete: function (data) {
                    setDataForm(dataForm)
                    $paginateButton.prop('disabled', false);
                    $paginateButton.attr('data-loading', 0);
                    Common.buttonReset($paginateButton, `<i aria-hidden="true" class="fa fa-arrow-down"></i> Tải thêm các cảm nhận`);
                }
            });

        })
    },

    initActions: function () {
        $('.toggle-comment').click(function (e) {
            e.preventDefault();

            let scrollTarget = '#commentForm';
            // Scroll to element with timeout to let content show
            setTimeout(function () {
                var $scrolling = UIkit.scroll({duration: 500, offset: 30, animation: 'uk-animation-fade'});
                $scrolling.scrollTo(scrollTarget);
            }, 300);
        })

        // $(document).on("submit", "form.kf-comment__form", function (e) {
        //     //stop submitting the form to see the disabled button effect
        //     // e.preventDefault();
        //
        //     let $btn = $(this).find('button[type=submit]');
        //     let text = $btn.html();
        //     //disable the submit button
        //     Common.buttonLoading($btn, text)
        //
        //     return true;
        // });

        $(document).on('click', '.btn-like-comment', function (){
            let $btn = $(this);
            let url = $btn.data('url');
            let dataForm = $btn.data('form');
            $btn.prop('disabled', true);
            $.ajax({
                type: 'POST',
                url: url,
                data: dataForm,
                dataType: 'json',
                success: function (resp) {
                    switch (resp.code){
                        case 1:
                            $btn.find('.comment-like-count').html(resp.data.c_countlike)
                            break;
                        default:
                            $btn.prop('disabled', false);
                    }

                }
            });
        })
    },
};

$(document).ready(function () {
    CommentClass.init();
    CommentClass.initLoadMore();
    CommentClass.initActions();
})




